import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { ConfigContext } from "../../providers/ConfigContext";
import { getDisplayImageUrl } from "../../utils/imageUtils";

const PLATFORM_ICONS = {
  instagram: 'fa-brands fa-instagram',
  facebook: 'fa-brands fa-facebook-f',
  tiktok: 'fa-brands fa-tiktok',
  twitter: 'fa-brands fa-x-twitter',
  youtube: 'fa-brands fa-youtube',
  whatsapp: 'fa-brands fa-whatsapp'
};

const Footer = () => {
  const [socialLinks, setSocialLinks] = useState([]);
  const { config } = React.useContext(ConfigContext);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/home-content`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data.data?.socialLinks)) {
          setSocialLinks(data.data.socialLinks.filter(l => l.enabled && l.url));
        }
      })
      .catch(() => {});
  }, []);

  return (
    <footer style={{
      background: '#ffffff',
      borderTop: '1px solid var(--border-light)',
      color: 'var(--text-primary)',
      marginTop: 'auto',
      fontFamily: 'var(--font-body)'
    }}>
      {/* Main Footer */}
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: '1.5fr 1fr 1fr 1fr',
        gap: '40px',
        padding: '60px 40px 40px'
      }}>
        {/* Brand */}
        <div>
          {config?.brand?.logo ? (
            <div style={{ marginBottom: '16px' }}>
              <img 
                src={getDisplayImageUrl(config.brand.logo)} 
                alt={config?.brand?.name || 'Tienda'} 
                style={{ maxHeight: '40px', maxWidth: '200px', objectFit: 'contain' }} 
              />
            </div>
          ) : (
            <div style={{
              fontFamily: 'var(--font-accent)',
              fontSize: '1.4rem',
              fontWeight: 600,
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              marginBottom: '16px'
            }}>
              {config?.brand?.name || 'E-MOREIRA'}
            </div>
          )}
          <p style={{
            color: 'var(--text-muted)',
            fontSize: '0.85rem',
            lineHeight: 1.7,
            marginBottom: '20px'
          }}>
            Moda femenina con las últimas tendencias. Prendas de calidad premium con envíos a todo el país.
          </p>
          <div style={{ display: 'flex', gap: '12px' }}>
            {socialLinks.length > 0 ? socialLinks.map((link, i) => (
              <a key={i} href={link.url} target="_blank" rel="noopener noreferrer" style={{
                width: '36px', height: '36px', border: '1px solid var(--border-light)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: 'var(--text-primary)', fontSize: '0.9rem', textDecoration: 'none',
                transition: 'all 0.3s ease'
              }}
                onMouseEnter={e => { e.currentTarget.style.background = 'var(--brand-primary)'; e.currentTarget.style.color = '#fff'; e.currentTarget.style.borderColor = 'var(--brand-primary)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--text-primary)'; e.currentTarget.style.borderColor = 'var(--border-light)'; }}
              >
                <i className={PLATFORM_ICONS[link.platform] || 'fas fa-globe'}></i>
              </a>
            )) : (
              <>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" style={{
                  width: '36px', height: '36px', border: '1px solid var(--border-light)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: 'var(--text-primary)', fontSize: '0.9rem', textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
                  onMouseEnter={e => { e.currentTarget.style.background = 'var(--brand-primary)'; e.currentTarget.style.color = '#fff'; e.currentTarget.style.borderColor = 'var(--brand-primary)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--text-primary)'; e.currentTarget.style.borderColor = 'var(--border-light)'; }}
                >
                  <i className="fa-brands fa-instagram"></i>
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={{
                  width: '36px', height: '36px', border: '1px solid var(--border-light)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: 'var(--text-primary)', fontSize: '0.9rem', textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
                  onMouseEnter={e => { e.currentTarget.style.background = 'var(--brand-primary)'; e.currentTarget.style.color = '#fff'; e.currentTarget.style.borderColor = 'var(--brand-primary)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--text-primary)'; e.currentTarget.style.borderColor = 'var(--border-light)'; }}
                >
                  <i className="fa-brands fa-facebook-f"></i>
                </a>
              </>
            )}
          </div>
        </div>

        {/* Help */}
        <div>
          <h4 style={{
            fontSize: '0.75rem',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.15em',
            marginBottom: '20px',
            fontFamily: 'var(--font-body)',
            color: 'var(--text-primary)'
          }}>
            Ayuda
          </h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {[
              { label: 'Cambios y Devoluciones', to: '#' },
              { label: 'Envíos', to: '#' },
              { label: 'Cómo Comprar', to: '#' },
              { label: 'Formas de Pago', to: '#' }
            ].map(item => (
              <li key={item.label} style={{ marginBottom: '10px' }}>
                <Link to={item.to} style={{
                  color: 'var(--text-muted)',
                  fontSize: '0.82rem',
                  textDecoration: 'none',
                  transition: 'color 0.3s ease',
                  letterSpacing: '0.02em'
                }}
                  onMouseEnter={e => e.target.style.color = 'var(--text-primary)'}
                  onMouseLeave={e => e.target.style.color = 'var(--text-muted)'}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Quick Links */}
        <div>
          <h4 style={{
            fontSize: '0.75rem',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.15em',
            marginBottom: '20px',
            fontFamily: 'var(--font-body)',
            color: 'var(--text-primary)'
          }}>
            Tienda
          </h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {[
              { label: 'Tienda', to: '/tienda' },
              { label: 'Mi Carrito', to: '/cart' },
              { label: 'Mi Cuenta', to: '/profile' },
              { label: 'Contacto', to: '#' }
            ].map(item => (
              <li key={item.label} style={{ marginBottom: '10px' }}>
                <Link to={item.to} style={{
                  color: 'var(--text-muted)',
                  fontSize: '0.82rem',
                  textDecoration: 'none',
                  transition: 'color 0.3s ease',
                  letterSpacing: '0.02em'
                }}
                  onMouseEnter={e => e.target.style.color = 'var(--text-primary)'}
                  onMouseLeave={e => e.target.style.color = 'var(--text-muted)'}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Payment */}
        <div>
          <h4 style={{
            fontSize: '0.75rem',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.15em',
            marginBottom: '20px',
            fontFamily: 'var(--font-body)',
            color: 'var(--text-primary)'
          }}>
            Métodos de Pago
          </h4>
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            {[
              { icon: 'fa-brands fa-cc-mastercard', title: 'Mastercard' },
              { icon: 'fa-brands fa-cc-visa', title: 'Visa' },
              { icon: 'fa-brands fa-cc-amex', title: 'Amex' },
              { icon: 'fa-solid fa-building-columns', title: 'Transferencia' }
            ].map(m => (
              <div key={m.title} title={m.title} style={{
                color: 'var(--text-muted)',
                fontSize: '1.4rem'
              }}>
                <i className={m.icon}></i>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div style={{
        borderTop: '1px solid var(--border-light)',
        padding: '20px 40px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '10px',
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        <p style={{ color: 'var(--text-light)', fontSize: '0.75rem', margin: 0, letterSpacing: '0.05em' }}>
          &copy; {new Date().getFullYear()} {config?.brand?.name || 'E-MOREIRA'}. Todos los derechos reservados.
        </p>
        <p style={{ color: 'var(--text-light)', fontSize: '0.75rem', margin: 0 }}>
          Desarrollado por <a href="https://dev.moreira.uy" target="_blank" rel="noopener noreferrer" style={{
            color: 'var(--text-muted)', textDecoration: 'none'
          }}>Moreira dev</a>
        </p>
      </div>

      {/* Responsive styles */}
      <style>{`
        @media (max-width: 992px) {
          footer > div:first-child {
            grid-template-columns: 1fr 1fr !important;
          }
        }
        @media (max-width: 576px) {
          footer > div:first-child {
            grid-template-columns: 1fr !important;
            text-align: center;
            padding: 30px 20px !important;
          }
          footer > div:first-child > div:first-child > div:last-child {
            justify-content: center;
          }
          footer > div:last-child {
            flex-direction: column;
            text-align: center;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;